import { FullsizeDialog } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { CustomArticleItemResponse } from "@tm/data/basket"
import { OwnArticlestByCategory } from "@bundles/compilations/components/OwnArticlestByCategory"

type Props = {
    open: boolean
    onClose(open: boolean): void
    genArtNr: number
    replaceConsumable: (consumable: CustomArticleItemResponse) => void
    genArtLabel?: string
}

export default function ReplaceConsumable({ genArtLabel, open, onClose, genArtNr, replaceConsumable }: Props) {
    const { translateText } = useLocalization()

    const handleClose = () => {
        onClose(false)
    }

    function onConsumableReplace(selected: CustomArticleItemResponse) {
        replaceConsumable(selected)
        handleClose()
    }

    if (open) {
        return null
    }

    return (
        <FullsizeDialog open>
            <OwnArticlestByCategory
                title={genArtLabel ?? translateText(616)}
                productGroupId={genArtNr}
                onConsumableReplace={onConsumableReplace}
                onClose={handleClose}
            />
        </FullsizeDialog>
    )
}
